import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import App from "./App";
import store from "./store";
import { google } from "./config";

const app = (
  <Provider store={store}>
    <GoogleReCaptchaProvider
      reCaptchaKey={google.RECAPTCHA_V3_SITE_KEY}
      language="en"
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "head",
      }}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </GoogleReCaptchaProvider>
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));
